import { render, staticRenderFns } from "./agreementText.vue?vue&type=template&id=1be0233c"
import script from "./agreementText.vue?vue&type=script&lang=js"
export * from "./agreementText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports